import { Layout } from "@/components";
import Vue, { ComponentOptions, AsyncComponent } from "vue";
import { RedirectOption } from "vue-router";

type Component =
  | ComponentOptions<Vue>
  | typeof Vue
  | AsyncComponent
  | Promise<typeof import("*.vue")>;

interface IMeta {
  title?: string; // 设置该路由在侧边栏和面包屑中展示的名字 不设置时不展示
  icon?: string; // 设置该路由在左侧菜单展示的图标 element-ui的icon
  breadcrumbAll?: boolean; //(默认 true)如果设置为false，则整个面包屑不会显示 此时可以自己在页面中写自定义的面包屑
  breadcrumb?: boolean; // (默认 true)如果设置为false，该路由则不会在breadcrumb面包屑中显示
  breadcrumbTo?: boolean; // (默认 true)该路由对应的面包屑是否可以点击
  activeMenu?: string; // 指定要高亮的左侧边栏的菜单 在跳转菜单的子页面但是想高亮左侧边栏时非常有用
  auth?: string; // 权限点唯一标识key 不配置时默认都可见 配置时权限接口返回的数组中需包含该key才会展示
}

export interface IBaseRouter {
  path: string; // 路由
  name?: string; // 名称
  children?: IBaseRouter[]; // 子路由
  redirect?: RedirectOption; // 路由重定向
  meta?: IMeta;
  hidden?: boolean; // (默认 false)当设置 true 的时候该路由不会在侧边栏出现 如401，login等页面，或者如一些子页面编辑页面/edit/1
  component?: Component; // 路由渲染的组件页面
  props?: boolean; // 当 props 设置为 true 时，route.params 将被设置为组件的 props。
}

const routes: Array<IBaseRouter> = [
  {
    path: "/",
    redirect: "/home",
    hidden: true,
  },
  {
    path: "/login",
    name: "login",
    hidden: true,
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: Layout,
    redirect: "/home/index",
    meta: {
      title: "数据中心",
      icon: "el-icon-s-home",
    },
    children: [
      {
        path: "index",
        name: "index",
        hidden: true,
        component: () => import("../views/Home.vue"),
        meta: {
          title: "数据中心",
          breadcrumb: false,
        },
      },
      {
        path: "bar/:width/:height",
        name: "bar",
        props: true,
        hidden: true,
        component: () => import("@/components/echarts/Bar.vue"),
        meta: {
          title: "柱状图",
          activeMenu: "/home/index",
        },
      },
      {
        path: "pie/:width/:height",
        name: "pie",
        props: true,
        hidden: true,
        component: () => import("@/components/echarts/Pie.vue"),
        meta: {
          title: "饼图",
          activeMenu: "/home/index",
        },
      },
      {
        path: "line/:width/:height",
        name: "line",
        props: true,
        hidden: true,
        component: () => import("@/components/echarts/Line.vue"),
        meta: {
          title: "折线图",
          activeMenu: "/home/index",
        },
      },
    ],
  },
  {
    path: "/User",
    name: "User",
    component: Layout,
    redirect: "/User/basic",
    meta: {
      title: "用户管理",
      icon: "el-icon-s-grid",
    },
    children: [
	  {
	    path: "basic",
	    name: "basic",
	    component: () => import("../views/User/allUser.vue"),
	    meta: {
	      title: "全部用户",
	    },
	  },
	  {
	    path: "consumeRecord",
	    name: "consumeRecord",
	    component: () => import("../views/User/consumeRecord.vue"),
	    meta: {
	      title: "消费记录",
	    },
	  },
	  {
	    path: "balanceDynamic",
	    name: "balanceDynamic",
	    component: () => import("../views/User/balanceDynamic.vue"),
	    meta: {
	      title: "余额动态",
	    },
	  },
	  {
	    path: "withdrawalRecord",
	    name: "withdrawalRecord",
	    component: () => import("../views/User/withdrawalRecord.vue"),
	    meta: {
	      title: "提现记录",
	    },
	  },
	  {
	    path: "editUser",
	    name: "editUser",
	    props: true,
	    hidden: true,
	    component: () => import("@/views/User/editUser.vue"),
	    meta: {
	      title: "编辑用户",
	      activeMenu: "/basic/basic1",
	    },
	  },
	  {
		path: "editBalance",
		name: "editBalance",
		props: true,
		hidden: true,
		component: () => import("@/views/User/editBalance.vue"),
		meta: {
			title: "余额充扣",
			activeMenu: "/User/editBalance",
		},
	  },{
		path: "withdrawalHandle",
		name: "withdrawalHandle",
		props: true,
		hidden: true,
		component: () => import("@/views/User/withdrawalHandle.vue"),
		meta: {
			title: "人工处理",
			activeMenu: "/User/withdrawalHandle",
		},
	  }
    ],
  },
  {
      path: "/Firm",
      name: "Firm",
      component: Layout,
      redirect: "/Firm/allFirm",
      meta: {
        title: "商家管理",
        icon: "el-icon-s-grid",
      },
      children: [
        {
          path: "allFirm",
          name: "allFirm",
          component: () => import("../views/Firm/allFirm.vue"),
          meta: {
            title: "全部商家",
          },
		},
		{
		    path: "checkFirm",
		    name: "checkFirm",
		    component: () => import("../views/Firm/checkFirm.vue"),
		    meta: {
		      title: "商家认证",
		    },
		},
		{
		    path: "allOrder",
		    name: "allOrder",
		    component: () => import("../views/Firm/allOrder.vue"),
		    meta: {
		      title: "全部订单",
		    },
		},
		{
		    path: "allTurnover",
		    name: "allTurnover",
		    component: () => import("../views/Firm/allTurnover.vue"),
		    meta: {
		      title: "全部流水",
		    },
		},
		{
		    path: "cashReturnList",
		    name: "cashReturnList",
		    component: () => import("../views/Firm/cashReturnList.vue"),
		    meta: {
		      title: "返现订单",
		    },
		},
		{
		    path: "account",
		    name: "account",
		    component: () => import("../views/Firm/account.vue"),
		    meta: {
		      title: "账户资金",
		    },
		},
		{
		    path: "withdrawal",
		    name: "withdrawal",
		    component: () => import("../views/Firm/withdrawal.vue"),
		    meta: {
		      title: "资金提现",
		    },
		},
		{
			path: "editFirm",
			name: "editFirm",
			props: true,
			hidden: true,
			component: () => import("@/views/Firm/editFirm.vue"),
			meta: {
				title: "编辑商家",
				activeMenu: "/Firm/editFirm",
			},
		},
		{
			path: "orderDetail",
			name: "orderDetail",
			props: true,
			hidden: true,
			component: () => import("@/views/Firm/orderDetail.vue"),
			meta: {
				title: "订单详情",
				activeMenu: "/Firm/orderDetail",
			},
		},
		{
			path: "firmOrder",
			name: "firmOrder",
			props: true,
			hidden: true,
			component: () => import("@/views/Firm/firmOrder.vue"),
			meta: {
				title: "商家订单",
				activeMenu: "/Firm/firmOrder",
			},
		}
      ],
  },
  {
      path: "/GoodsManage",
      name: "GoodsManage",
      component: Layout,
      redirect: "/GoodsManage/goodsList",
      meta: {
        title: "商品管理",
        icon: "el-icon-s-grid",
      },
      children: [
        {
          path: "goodsList",
          name: "goodsList",
          component: () => import("../views/GoodsManage/goodsList.vue"),
          meta: {
            title: "商品总库",
          },
        },
		{
		  path: "goodsCheck",
		  name: "goodsCheck",
		  component: () => import("../views/GoodsManage/goodsCheck.vue"),
		  meta: {
		    title: "商品审核",
		  },
		},
		{
		  path: "goodsCategory",
		  name: "goodsCategory",
		  component: () => import("../views/GoodsManage/goodsCategory.vue"),
		  meta: {
		    title: "商品类目",
		  },
		},
		{
			path: "goodsDetail",
			name: "goodsDetail",
			props: true,
			hidden: true,
			component: () => import("@/views/GoodsManage/goodsDetail.vue"),
			meta: {
				title: "商品详情",
				activeMenu: "/GoodsManage/goodsDetail",
			},
		}
      ],
    },
   {
      path: "/Brand",
      name: "Brand",
      component: Layout,
      redirect: "/Brand/baseBrand",
      meta: {
        title: "品牌管理",
        icon: "el-icon-s-operation",
      },
      children: [
        {
          path: "brandManage",
          name: "brandManage",
          component: () => import("../views/Brand/brandManage.vue"),
          meta: {
            title: "品牌管理",
          },
        },
       {
          path: 'addBrand',
          name: 'addBrand',
          component: () => import('../views/Brand/addBrand.vue'),
          meta: {title: '添加品牌'},
          hidden: true,
          props: true,
       },
  	   {
  	      path: 'editBrand',
  	      name: 'editBrand',
  	      component: () => import('../views/Brand/editBrand.vue'),
  	      meta: {title: '编辑品牌'},
  	      hidden: true,
  	      props: true,
  	   },
  	 //   {
  		//   path: "brandType",
  		//   name: "brandType",
  		//   component: () => import("../views/Brand/brandType.vue"),
  		//   meta: {
  		//     title: "商品类型",
  		//   },
  		// },
  		{
  		  path: "brandSecondType",
  		  name: "brandSecondType",
  		  props: true,
  		  hidden: true,
  		  component: () => import("../views/Brand/brandSecondType.vue"),
  		  meta: {
  		    title: "商品类型",
  			  activeMenu: "/brandType/brandSecondType",
  		  },
  		},
		{
		  path: "checkBrand",
		  name: "checkBrand",
		  component: () => import("../views/Brand/checkBrand.vue"),
		  meta: {
		  	title: "品牌审核",
		  },
		},
		{
			path: "brandDetail",
			name: "brandDetail",
			props: true,
			hidden: true,
			component: () => import("@/views/Brand/brandDetail.vue"),
			meta: {
				title: "商品详情",
				activeMenu: "/Brand/brandDetail",
			},
		},
		
      ],
    }, 
	{
	   path: "/Community",
	   name: "Community",
	   component: Layout,
	   redirect: "/Community/allQualityTest",
	   meta: {
	     title: "社区管理",
	     icon: "el-icon-s-grid",
	   },
	   children: [
	     {
	       path: "allQualityTest",
	       name: "allQualityTest",
	       component: () => import("../views/Community/allQualityTest.vue"),
	       meta: {
	         title: "全部品测",
	       },
	     },{
		    path: 'qualityTestDetail',
		    name: 'qualityTestDetail',
		    component: () => import('../views/Community/qualityTestDetail.vue'),
		    meta: {title: '品测详情'},
		    hidden: true,
		    props: true,
		  },{
		   path: "qualityTestCheck",
		   name: "qualityTestCheck",
		   component: () => import("../views/Community/qualityTestCheck.vue"),
		   meta: {
		     title: "品测列表",
		   },
		 },{
			 
			 path: 'checkDetail',
			 name: 'checkDetail',
			 component: () => import('../views/Community/checkDetail.vue'),
			 meta: {title: '品测审核详情'},
			 hidden: true,
			 props: true,
			 
		 },
		 {
		   path: "allComment",
		   name: "allComment",
		   component: () => import("../views/Community/allComment.vue"),
		   meta: {
		     title: "全部评论",
		   },
		 },
		 {
		   path: "commentCheck",
		   name: "commentCheck",
		   component: () => import("../views/Community/commentCheck.vue"),
		   meta: {
		     title: "评论审核",
		   },
		 },
	   ],
	},
	{
	   path: "/Protocol",
	   name: "Protocol",
	   component: Layout,
	   redirect: "/Protocol/protocolList",
	   meta: {
	     title: "协议条款",
	     icon: "el-icon-s-grid",
	   },
	   children: [
	     {
	       path: "protocolList",
	       name: "protocolList",
	       component: () => import("../views/Protocol/protocolList.vue"),
	       meta: {
	         title: "协议列表",
	       },
	     },
		 {
		    path: 'addprotocol',
		    name: 'addprotocol',
		    component: () => import('../views/Protocol/addprotocol.vue'),
		    meta: {title: '添加协议'},
		    hidden: true,
		    props: true,
		 },
		 {
			 path: 'protocolDetail',
			 name: 'protocolDetail',
			 component: () => import('../views/Protocol/protocolDetail.vue'),
			 meta: {title: '协议详情'},
			 hidden: true,
			 props: true,
		 },
	   ],
	},
    
  
  
];

export default routes;
